export enum CronJobList {
    SyncProductsCron = "sync-products",
}
